import warningMsg, {
  confirmDialog
} from '@/components/NewEditForm/UILibrary/HYBElement/AlertDialog'

const hasDataError = (data: any) => {
  return Array.isArray(data) && data?.some?.((item: any) => item?.error_msg)
}
enum ActionCode {
  UNIVERSAL = 'UNIVERSAL',
  FORBIDDEN = 'FORBIDDEN',
  WARNING = 'WARNING'
}
interface ActionItem {
  title?: string
  text?: string
  onAction?: () => void
}
/**
 * 处理异常业务数据
 * @param param0 data - 后端数据 success - 是否成功 onSuccess - 成功回调 forbidden - 禁止回调 warning - 警告回调 universal - 普通错误回调
 * @returns void
 */
export default function dealException({
  data: arrayOrObject,
  success,
  onSuccess,
  forbidden,
  warning,
  universal
}: {
  data?: any[]
  success?: boolean
  onSuccess?: () => void
  forbidden?: ActionItem
  warning?: ActionItem
  universal?: ActionItem
}) {
  const data = Array.isArray(arrayOrObject) ? arrayOrObject : [arrayOrObject]
  if (data && data?.length > 0 && hasDataError(data)) {
    let actionCode = ActionCode.UNIVERSAL
    if (data && Array.isArray(data)) {
      if (data.findIndex((item: any) => item?.action_code === ActionCode.FORBIDDEN) > -1) {
        actionCode = ActionCode.FORBIDDEN
      } else if (data.findIndex((item: any) => item?.action_code === ActionCode.WARNING) > -1) {
        actionCode = ActionCode.WARNING
      }
    }
    switch (actionCode) {
      case ActionCode.UNIVERSAL:
        // 普通错误
        if (data?.[0]?.title || universal?.title) {
          warningMsg({ title: data?.[0]?.title || universal?.title, data, text: universal?.text })
        }
        universal?.onAction?.()
        return
      case ActionCode.WARNING:
        // 警告
        confirmDialog({
          title: data?.[0]?.title || '失败原因',
          data,
          text: warning?.text,
          onConfirm: warning?.onAction
        })
        return
      case ActionCode.FORBIDDEN:
        // 禁止
        warningMsg({ title: data?.[0]?.title || '失败原因', data, text: forbidden?.text })
        forbidden?.onAction?.()
        return
    }
  } else if (success) {
    // 成功
    onSuccess?.()
  }
}
